module.exports = __webpack_public_path__ + "static/media/WW-Portfolio_Website_Pages-07-sm.b2692a27.jpg";